export var StreamType;
(function (StreamType) {
    StreamType["DASH"] = "dash";
    StreamType["DASH_WIDEVINE"] = "dash_widevine";
    StreamType["HLS7"] = "hls7";
    StreamType["HLS7_FAIRPLAY"] = "hls7_fairplay";
})(StreamType || (StreamType = {}));
